export const CONTACT_INFORMATION = 'Contact Information';
export const BACK_TITLE = 'Back to Account Management';
export const ACA_CONTACT_DESCRIPTION =
  'Need to make changes? Please contact your marketplace exchange you used to signup for coverage.';
export const CMS_CONTACT_DESCRIPTION1 = 'Need to make changes? Please';
export const CMS_CONTACT_DESCRIPTION2 = 'contact customer service.';
export const CHIP_CONTACT_DESCRIPTION =
  'Need to make changes? Please contact CHIP Service at 1-800-543-7105 (TTY 711) weekdays 8:30 AM to 5:00 PM EST.';
export const ACA_OFF_CONTACT_DESCRIPTION = '';
export const ACA_SMALL_CONTACT_DESCRIPTION =
  'Need to make changes? Please talk to your employer.';
export const COMMERCIAL_CONTACT_DESCRIPTION =
  'Need to make changes? Please talk to your employer.';
export const SAVE_BTN = 'Save Changes';
export const REQUIRED_FIELDS = '*Required fields';
export const SUBMIT_BTN = 'Submit';
export const CONFIRMATION_CODE = 'Confirmation Code';
export const VERIFY_EMAIL_TEXT = 'Your email is not verified. ';
export const VERIFIED_EMAIL_TEXT = 'Your email address is confirmed.';
export const VERIFY_EMAIL_TEXT2 = 'Click here to verify your email.';
export const ZIP_MAX_LENGTH = 5;
export const PHONE_MAX_LENGTH = 14;
export const ADDRESS_MAX_LENGTH = 50;
export const EMAIL_REQUIRED = 'Your email address is required.';
export const VALID_EMAIL = 'Enter a valid email address.';
export const VALID_ADDRESS =
  'Enter an address using letters, numbers, and symbols (we only accept #, /, &, % ).';
export const CITY_ERR = 'Enter a city using letters, numbers, and spaces.';
export const STATE_ERR = 'Select a state.';
export const ZIP_ERR = 'Enter a valid 5-digit zip code.';
export const PHONE_ERR = 'Enter a valid phone number.';
export const GENERAL_ERR = 'This field is required.';
export const ATTENTION = 'Attention';
export const ERROR = 'Error';
export const ALERT_MODAL_TEXT =
  'This will deselect your preference for paperless communication. Would you like to proceed?';
export const OK = 'OK';
export const CANCEL_BTN = 'Cancel';
export const EMAIL_CONFIRMATION_SENDBTN = 'Send Code';
export const EMAIL_CONFIRMATION_DIFFBTN = 'Use a Different Email';
export const API_FAILED_CONTENTSECOND = 'Please try again';
export const VERIFY_CODE = 'Verify Code';
export const RESEND_CODE = 'Resend Code';
export const SUCCESS = 'Success';
export const PREFERENCES_SAVED = 'Your preferences has been saved';
export const NEW_EMAIL_CONFIRM =
  'Please note that the new email address you verify will become the primary email address for your account.';
export const CONTINUE_DESCRIPTION = 'Do you wish to continue?';
export const YES = 'YES';
export const NO = 'NO';
export const CONFIRM_EMAIL_BTN = 'Confirm Email';
export const EMAIL_SELECT_DESCRIPTION =
  'To send you email communications, we’ll need to verify your email. Please enter it below.';
export const RESEND_DESCRIPTION =
  'If you cannot locate the email with the code, please check your spam or junk folder.';
export const CUSTOMER_SUPPORT_DESCRIPTION =
  "Something went wrong, but we'd like to make it right. For further assistance, please call the number on the back of your ID card or send us a message via the Support page.";
export const OPPS = 'Oops!';
export const ATTENTION_DESC = 'Your changes will not be saved.';
export const API_ERROR_DESC =
  "We're sorry, but an unexpected error has occurred. Please try again.";
export const ADDRESS = 'Address Line 1*';
export const ADDRESS2 = 'Address Line 2 (Optional)';
export const CITY = 'City*';
export const STATE = 'State*';
export const ZIP_CODE = 'Zip Code*';
export const PRIMARY_EMAIL = 'Personal Email*';
export const WORK_EMAIL = 'Work Email';
export const SECONDARY_EMAIL = 'Secondary Email';
export const SECONDARY_EMAIL_TOOLTIP_CONTENT_1 =
  'Your healthcare marketplace exchange-supplied email is the email address you provided for communications related to your health insurance marketplace account.';
export const SECONDARY_EMAIL_TOOLTIP_CONTENT_2 =
  'This email is used to receive important updates, notifications, and general marketplace-related information. However, it is not used to receive all health plan-specific documents or communications from your insurance carrier.';
export const SECONDARY_EMAIL_TOOLTIP_CONTENT_3 =
  'For all plan details, claims, billing, or other carrier-specific information, please refer to the contact information provided by your insurance company.';

export const MOBILE_PHONE_NUMBER = 'Mobile Phone Number';
export const WORK_PHONE_NUMBER = 'Work Phone Number';
export const HOME_PHONE_NUMBER = 'Home Phone Number';
export const NEW_EMAIL_ADDRESS_SAVED =
  'Your contact information has been updated.';
export const STATE_VALUE = [
  'AK',
  'AL',
  'AR',
  'AS',
  'AZ',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'GU',
  'HI',
  'IA',
  'ID',
  'IL',
  'IN',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'ME',
  'MI',
  'MN',
  'MO',
  'MP',
  'MS',
  'MT',
  'NC',
  'ND',
  'NE',
  'NH',
  'NJ',
  'NM',
  'NV',
  'NY',
  'OH',
  'OK',
  'OR',
  'PA',
  'PR',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VA',
  'VI',
  'VT',
  'WA',
  'WI',
  'WV',
  'WY',
];
